<div class="preview-dialog" [style.minHeight]="height + 'px'" [style.width]="'calc(100% - 810px)'">
    <div class="preview-dialog-header">
        <div class="action">
            <button class="color-primary" nz-button nzType="text" (click)="zoomIn()">
                <span nz-icon nzType="zoom-in" nzTheme="outline"></span>
            </button>
            <button class="color-primary" nz-button nzType="text">
                <span nz-icon nzType="border-outer" nzTheme="outline" (click)="originSize()"></span>
            </button>
            <button class="color-primary" nz-button nzType="text" (click)="zoomOut()">
                <span nz-icon nzType="zoom-out" nzTheme="outline"></span>
            </button>
        </div>
    </div>

    <div class="preview-dialog-body">
        <pdf-viewer [src]="environment.fileHost + currentFile.fileId + withToken" [c-maps-url]="'/assets/cmaps/'"
            [render-text]="true" [zoom-scale]="'page-fit'" [original-size]="false" style="width: 100%; height: 100%"
            [zoom]="pdfZoom" [(page)]="pdfPages" (pages-initialized)="onPageLoad($event)">
        </pdf-viewer>
    </div>
</div>
<div class="dialog" [style.width]="'810px'" [style.height]="'100%'" [style.padding]="'10px'">
    <div class="dialog-header">【交工检测报告】补充信息</div>
    <div class="dialog-body">
        <div class="grid">
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 报告编号
                </div>

                <div class="column required" [style.width]="686 + 'px'">
                    <input type="text" [(ngModel)]="record.fileSn" placeholder="输入报告编号">
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 交工部位
                </div>
                <div class="column required" [style.width]="100 + 'px'">
                    <select class="color-primary background-module" [(ngModel)]="sectionId" [disabled]="true">
                        <option *ngFor="let item of sectionList" [value]="item.id">{{item.name}}</option>
                    </select>
                </div>
                <div class="column required" [style.width]="586 + 'px'">
                    <nz-cascader class="color-primary" [nzShowSearch]="true" [nzOptions]="jgFbCascaderOptions"
                        [(ngModel)]="jgFbCascaderValue" (ngModelChange)="onFbCascaderValueChange()">
                    </nz-cascader>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    提交日期
                </div>
                <div class="column" [style.width]="686 + 'px'">
                    <nz-date-picker [nzSuffixIcon]="''" nzPlaceHolder=" 输入表单生成并提交签字的日期" nzFormat="yyyy-MM-dd"
                        [(ngModel)]="record.fileSubmitDateDate">
                    </nz-date-picker>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="80 + 'px'">
                    <span class="color-danger">*</span> 完成日期
                </div>
                <div class="column required" [style.width]="686 + 'px'">
                    <nz-date-picker [nzSuffixIcon]="''" nzPlaceHolder=" 输入表单签字盖章完成的日期" nzFormat="yyyy-MM-dd"
                        [(ngModel)]="record.fileFinishDateDate">
                    </nz-date-picker>
                </div>
            </div>
        </div>
        <div class="grid" [style.marginTop]="'1rem'">
            <div class="row">
                <div class="column background-page" [style.width]="40 + 'px'">
                    <input type="checkbox" [(ngModel)]="checkAll" (ngModelChange)="onCheckAllChange()">
                </div>
                <div class="column background-page" [style.width]="300 + 'px'">
                    关联报检单
                </div>
                <div class="column background-page" [style.width]="50 + 'px'">
                    数量
                </div>
                <div class="column background-page" [style.width]="376 + 'px'">
                    工程部位
                </div>
            </div>
            <div class="record-list" [style.height.px]="recordListHeight">
                <div class="row" *ngFor="let item of recordList">
                    <div class="column" [style.width]="40 + 'px'">
                        <input type="checkbox" [(ngModel)]="item.checked" (ngModelChange)="onCheckChange()">
                    </div>
                    <div class="column text-left {{item.checked ? 'color-primary' : ''}}" [style.width]="300 + 'px'">
                        {{item.formSn}} {{item.jgFxName}}-{{item.jgInspItemName}}
                    </div>
                    <div class="column clickable {{item.checked ? 'color-primary' : ''}}"
                        (click)="reports(item.workFlowId!)" [style.width]="50 + 'px'">
                        {{item.sectionItemNum}}
                    </div>
                    <div class="column {{item.checked ? 'color-primary' : 'color-grey'}}" [style.width]="376 + 'px'">
                        <format-data [contentStr]="item.sectionItemSummary" [patternStr]="'E+370'">
                        </format-data>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确认</button>
    </div>
</div>